import React from "react";
import Image from "next/image";
import Body from "components/Body";

export default function NodeNewsContent({ node, ...props }) {
  return (
    <article {...props}>
      {node.field_image?.uri && (
        <figure className="mb-16">
          <Image
            src={`${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}${node.field_image.uri.url}`}
            width={974}
            height={550}
            layout="responsive"
            objectFit="cover"
            alt={node.field_image.resourceIdObjMeta.alt}
          />
          {node.field_image.resourceIdObjMeta.title && (
            <figcaption className="py-2 text-sm text-center text-gray-600">
              {node.field_image.resourceIdObjMeta.title}
            </figcaption>
          )}
        </figure>
      )}
      {node.body?.processed && (
        <div className="prose">
          <Body value={node.body?.processed} />
        </div>
      )}
    </article>
  );
}
